'use client';

import { useCallback } from 'react';
import useDriftClient from 'src/hooks/useDriftClient';
import {
	DriftClientTxSignedHandler,
	TxMetricsOpts,
} from 'src/stores/DriftStore/types';
import { sendTxAndRecordConfirmationTime } from 'src/stores/DriftStore/helpers/transactionHelpers';

/**
 * Hook for handling transaction chains with proper metrics and confirmation tracking
 */
export const useHandleTxChain = () => {
	const driftClient = useDriftClient();

	const handleTxChain = useCallback(
		async <T>(
			txPromise: T,
			onSigned?: DriftClientTxSignedHandler,
			opts?: TxMetricsOpts
		) => {
			if (!driftClient) return;
			return sendTxAndRecordConfirmationTime(
				driftClient,
				txPromise,
				onSigned,
				opts
			);
		},
		[driftClient]
	);

	return { handleTxChain };
};
